import {
    UserSituationBooleanValue,
    UserSituationWhatIsYourCurrentPropertyGoalValue
} from '../../graphql.generated';

export type AnswerData = Record<string, string>;

export type QuestionProps = {
    label: string;
    options: QuestionOption[];
    initialValue: QuestionOption | undefined;
    name: string;
    ariaDescribedBy?: string;
    subtitle?: string;
    formatFieldAnswer: (answer: QuestionOption) => string;
    analyticsPage: string;
    action: {
        onSubmit: (data: AnswerData, questionId: string) => Promise<void>;
        onSaved?: (selection: { value: string; name: string }) => void;
        onEdit?: (questionName: string) => void;
        loading?: boolean;
        error?: boolean;
    };
    required?: boolean;
    autoFocus?: boolean;
    showEditButton?: boolean;
};

export type FocusableElement = HTMLButtonElement & HTMLDivElement;

export type QuestionOption = {
    value: string;
    label: string;
};

export type QuestionNames =
    | 'situationWhatIsYourCurrentPropertyGoal'
    | 'situationAreYouAFirstTimeBuyer'
    | 'situationAreYouSellingAProperty'
    | 'situationIsItAlreadyOnTheMarket'
    | 'situationAreYouAPropertyInvestor'
    | 'situationAreYouLookingToBuy'
    | 'situationAreYouAHomeowner';

const isEnumMember = <T extends Record<string, string>>(
    enumerator: T,
    value: string
): value is T[keyof T] => {
    for (const k in enumerator) {
        if (enumerator[k] === value) {
            return true;
        }
    }

    return false;
};

export const checkIsGoalValue = (
    value: string
): value is UserSituationWhatIsYourCurrentPropertyGoalValue => {
    return isEnumMember(UserSituationWhatIsYourCurrentPropertyGoalValue, value);
};

export const checkIsSituationValue = (
    value: string
): value is UserSituationBooleanValue => {
    return isEnumMember(UserSituationBooleanValue, value);
};
